import { Box, styled } from '@mui/material';

export const FrontendIcon = styled(Box)(({ theme }) => [
    {
        border: `2px solid ${(theme.vars || theme).palette.grey[300]}`,
        borderRadius: theme.spacing(1),
        width: '56px',
        height: '56px',
        backgroundColor: (theme.vars || theme).palette.grey[100],
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
]);
